import "../../assets/css/main.css";
import "../../assets/css/layout.css";
import "../../assets/css/page.css";
import "../../assets/css/home.css";
import "../../assets/css/form.css";
import "../../assets/css/slick.css";
import "../../assets/css/jquery.fancybox.min.css";
import "../../assets/css/nice-select.css";
import Header from "../Header";
import Footer from "../Footer";
import Script from "../Script";
import { Outlet } from "react-router-dom";

export default function WebLayout() {
  return (
    <div className="web-app-new-project-1234">
      <Header />
      <Outlet />
      <Footer />
      <Script />
    </div>
  );
}
